import { Injectable } from "@angular/core";
import { Chart } from "angular-highcharts";

@Injectable({
  providedIn: "root"
})
export class GenerateColumnChart {

  constructor() { }

  public getChart(): Chart {
    return new Chart({
      chart: {
        styledMode: true,
        type: 'column',
        zoomType: 'x',
        events: {
          load() {
            const chart = this;
            chart.reflow();
          }
        }
      },
      title: {
        text: ''
      },
      xAxis: {
        crosshair: true,
      },
      yAxis: {
        title: {
          text: ''
        },
        minPadding: 0.6
      },
      credits: {
        enabled: false
      },
      tooltip: {
        shared: true,
        followPointer: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          pointWidth: 2,
          groupPadding:0.2
        }
      }
    });
  }

}
